export const ViewForm = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col md:flex-row text-sm gap-4">{children}</div>
)

export const ViewFormItem = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <div className="flex items-center">
    <div className="text-muted-foreground w-4/12 pr-2">{label}</div>
    {children}
  </div>
)

export const ViewFormColumn = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col gap-2 md:w-6/12">{children}</div>
)
